import React, { useEffect, useMemo, useState } from 'react';
import MainTable from '../../components/MainTable/MainTable';
import "./Projects.css"
import FiltersIcon from '../../assets/svg/filters';
import PlusIcon from '../../assets/svg/plus';
import SearchIcon from '../../assets/svg/search';
import { useNavigate } from 'react-router-dom';
import Modal from 'react-bootstrap/Modal';
import CloseCircleIcon from '../../assets/svg/closeCircle';
import { useDispatch, useSelector } from 'react-redux';
import { clearFormVals, setFleg } from '../../store/YamatReducer';
import Filters from './Filters';

export default function Projects(props){

    const initialFiltersState = {
        populationType: "",
        contact: "",
        hours: "", 
        activityType: "", 
        participateNumber: "",
        madeForCompany: "" 
    }
    const [activeCloseBtn, setActiveCloseBtn] = useState(false)
    const store = useSelector(state => state.reducer)
    const [tableRows, setTableRows] = useState(props.projectTableRows)
    const [modalShow, setModalShow] = useState(false)
    const [filtersShow, setFiltersShow] = useState(false)
    const [filters, setFilters] = useState(initialFiltersState)
    const [searchValue, setSearchValue] = useState("")
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const closed = props.type === "closed"
    const popupTextObj = closed ? "MunicipalitiesMainPageClosed" : "MunicipalitiesMainPageIntroduction"
    const popupInfoIndex = props.mainDataObj?.PopupPages?.findIndex(x => x.PopupPageTypeDictionary.Value === popupTextObj)
    const feedbackPopupInfoIndex = props.mainDataObj?.PopupPages?.findIndex(x => x.PopupPageTypeDictionary.Value === "MunicipalitiesProjectFeedback") 
    const linkStatus = props.mainDataObj?.municipality?.link?.status

    const totals = useMemo(() => {
        const projects = props.mainDataObj?.projects || []
        const hasCancelled = projects.some(p => p.status === "cancelled")
        if (!hasCancelled) return props.mainDataObj?.details || {}
        const active = projects.filter(p => p.status !== "cancelled")
        return {
            totalBudgetFromRuachTova: active.reduce((sum, p) => {
                const budgetItems = p.budget?.details || []
                return sum + budgetItems.reduce((itemSum, item) => itemSum + (item.budgetFromRuachTova || 0), 0)
            }, 0),
            totalApproved: active.reduce((sum, p) => sum + (p.budget?.approved || 0), 0),
            totalProjectsCount: active.length,
            totalNumVolunteersGuests: active.reduce((sum, p) => sum + (p.attributes?.numVolunteersGuests || 0), 0),
            totalProjectsWithFeedback: active.filter(p => p.feedback).length,
            totalProjectsWithoutFeedback: active.filter(p => !p.feedback).length,
        }
    }, [props.mainDataObj?.projects, props.mainDataObj?.details])

    useEffect(() => {  
        if(typeof(props.projectTableRows) !== 'undefined'){
            setTableRows(props.projectTableRows)
        }
    }, [props.type, props.projectTableRows])

    useEffect(() => {
        if(!store.fleg.welcomPopup && popupInfoIndex !== -1){
            setModalShow(true)
            dispatch(setFleg({key: 'welcomPopup', value: true}))
        }
        
    }, [ store.fleg.welcomPopup, tableRows])

    const searchInTable = (e) => {
        setSearchValue(e.target.value)
    }

    return (
        <>
            <div className={`container-fluid Projects ${closed ? "closed" : ""}`}>
                {(props.type === "projects" || closed) && props.mainDataObj && <div className='title_con'>
                    <h1 className='font-xxl mb-0 title mb-3'>פרויקטים עירוניים - {props.mainDataObj?.municipality?.name}</h1>
                </div>}
                {props.mainDataObj && <div className={`row mb-3 ${closed ? "flex-column-reverse" : ""}`}>
                    <div className={`col-6 ${closed ? 'mt-4 pt-3' : ''} align-items-end`}>
                        {props.type !== 'archive' && <div className="main_table_buttons align-items-end d-flex h-100">
                                {props.type === 'projects' && <div className=''>
                                    <button type="button" onClick={() => {dispatch(clearFormVals()); navigate(`/${store.locationIdent}/action-form`)}} className="main_page_btn btn btn-primary d-flex justify-content-between align-items-center px-2 me-1 ms-0">
                                        <span className='me-1 font-m'>הוספת פרויקט</span>
                                        <span className='btn_icon'><PlusIcon/></span>
                                    </button>
                                </div>}
                            <div className='relative'>
                                <button type="button" onClick={() => setFiltersShow(true)} className="main_page_btn btn btn-dark me-1 ms-0 d-flex justify-content-between align-items-center px-2">
                                    <span className='me-1 font-m'>פילטרים</span>
                                    <span className=''><FiltersIcon/></span>
                                </button>
                                {filtersShow && <Filters 
                                    setFiltersShow={setFiltersShow} 
                                    searchValue={searchValue}
                                    searchInTable={searchInTable}
                                    setFilters={setFilters}
                                    filters={filters}
                                    filterValues={props.filterValues}
                                    setSearchValue={setSearchValue}
                                    initialFiltersState={initialFiltersState}/>}
                            </div>
                            <div className="input-group search_input">
                                <input type="text" className="form-control font-m" value={searchValue} onChange={(e) => searchInTable(e)} placeholder="חיפוש" aria-label="search" aria-describedby="basic-addon1"/>
                                <span className="input-group-text " id="basic-addon1"><SearchIcon/></span>
                            </div>
                        </div>}
                    </div>
                    <div className={`col-${closed ? '12' : '6'} d-flex justify-content-end`}>

                        
                                <div className="databox font-l d-flex p-3 flex-column justify-content-between ms-1 me-0">
                                    <p className="mb-0 lh-sm">סך הכל תקציב הסיוע המבוקש מרוח טובה</p>
                                    <p className="primary_color mb-0 font-xxxl lh-1"><span>{totals.totalBudgetFromRuachTova}</span> <span>₪</span></p>
                                </div>
                                {closed && <div className="databox font-l d-flex p-3 flex-column justify-content-between ms-1 me-0">
                                    <p className="mb-0 lh-sm">סך הכל תקציב הסיוע המאושר ע"י רוח טובה</p>
                                    <p className="primary_color mb-0 font-xxxl lh-1"><span>{totals.totalApproved}</span> <span>₪</span></p>
                                </div>}
                                <div className="databox font-l d-flex p-3 flex-column justify-content-between ms-1 me-0">
                                    <p className="mb-0 lh-sm">סך הכל פרויקטים</p>
                                    <p className="primary_color mb-0 font-xxxl lh-1">{totals.totalProjectsCount}</p>
                                </div>
                                <div className="databox font-l d-flex p-3 flex-column justify-content-between ms-1 me-0">
                                    <p className="mb-0 lh-sm">סך הכל משתתפים בפרויקטים</p>
                                    <p className="primary_color mb-0 font-xxxl lh-1">{totals.totalNumVolunteersGuests}</p>
                                </div>
                                {closed && <div className="databox font-l d-flex p-3 flex-column justify-content-between ms-1 me-0">
                                    <p className="mb-0 lh-sm">סך הכל פרויקטים עם משוב</p>
                                    <p className="primary_color mb-0 font-xxxl lh-1">{totals.totalProjectsWithFeedback}</p>
                                </div>}
                                {closed && <div className="databox font-l d-flex p-3 flex-column justify-content-between ms-1 me-0">
                                    <p className="mb-0 lh-sm">סך הכל פרויקטים ללא משוב</p>
                                    <p className="primary_color mb-0 font-xxxl lh-1">{totals.totalProjectsWithoutFeedback}</p>
                                </div>}
                            
                        
                    </div>                 
                </div>}
                {props.mainDataObj ? 
                    <MainTable                         
                        type={props.type} 
                        mainDataObj={props.mainDataObj} 
                        getMainObjData={props.getMainObjData}
                        tableRows={tableRows} 
                        searchValue={searchValue} 
                        filters={filters} 
                        feedbackPopupInfoIndex={feedbackPopupInfoIndex}
                        leadColor={props.leadColor}
                    />:
                    <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
                        <div className="spinner-border" style={{color: props.leadColor}} role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>                  
                }
            </div> 
            <Modal
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                show={modalShow}
                onHide={() => setModalShow(false)}
            >
                {props.mainDataObj && <div className='f-reg px-5 py-5 relative'>
                    <div className='position-absolute close_circle_icon pointer' onClick={() => setModalShow(false)} onMouseLeave={() => setActiveCloseBtn(false)} onMouseEnter={() => setActiveCloseBtn(true)}><CloseCircleIcon active={activeCloseBtn} /></div>
                    {/* <h3 className='primary_color f-bold mt-3 mb-4' dangerouslySetInnerHTML={{__html: props.mainDataObj?.PopupPages[popupInfoIndex].Title}}></h3> */}
                    {closed ? 
                    <h3 className='primary_color f-bold mt-3 mb-4'>רישום הפרויקטים ליישובכם הסתיים</h3> : 
                    <h3 className='primary_color f-bold mt-3 mb-4'>שותפות ושותפים יקרים</h3>}
                    {/* <p dangerouslySetInnerHTML={{__html: props.mainDataObj?.PopupPages[popupInfoIndex].RawHTML}}></p> */}
                    {closed ? 
                    <div><p>אנו מודים לכם על נכונותכם להשתתף ביום מעשים טובים.</p><p>הפרויקטים שהזנתם נקלטו במערכת ומעתה לא ניתן להזין ו/או לערוך את הפרויקטים.</p><p>בשבועות הקרובים נקיים וועדות תקציב ולאחריהן נעדכנכם בדבר הקצאת המשאבים המיועדת לתמיכה בתכניתכם, בהתבסס על העקרונות המנחים לקיום יום מעשים טובים.</p><p>לנוחיותכם, להלן מוצגת רשימת כל הפרויקטים שהזנתם למערכת.</p><p>צוות יום מעשים טובים<br/> עמותת רוח טובה</p></div> :
                    <div>
                        <p><strong>ברוכות וברוכים הבאים למערכת יום מעשים טובים</strong></p>
                        <p>שמחים על השותפות, גם השנה מאוחדים בטוב.</p>
                        <p>לרשותכם פלטפורמה לריכוז כלל הפרויקטים שתגישו במסגרת התכנית הרשותית ליום מעשים טובים 2027.</p>
                        <p>להלן העקרונות המנחים לתכנית הפעילות הרשותית ביום מעשים טובים:</p>
                        <ol>
                            <li>פרויקטים בעלי אופי קהילתי, המקדמים חוסן קהילתי, ערכים של התנדבות וערבות הדדית</li>
                            <li>פעילות המשלבת מגוון אוכלוסיות והתנדבות מוטבים</li>
                            <li>פרויקטים תהליכיים הכוללים פעילות ייחודית ביום מעשים טובים (פרויקט הכולל מספר מפגשים אשר מקדם עשייה קהילתית-חברתית סביב נושא משותף)</li>
                            <li>התייחסות התכנית למאפייני התקופה ולמועדים בלוח השנה</li>
                            <li>לפחות פרויקט אחד להרשמה לקהל הרחב באתר יום מעשים טובים</li>
                            <li>התייחסות למספר המשתתפים בתמהיל הרשותי</li>
                            <li>השתתפות הרשות בתקציב ומשאבים</li>
                        </ol>
                        <p>הסיוע התקציבי יינתן עבור פעילות המתקיימת ביום מעשים טובים. בכפוף לעמידה בעקרונות המנחים</p>
                        <p><strong>יש לשים לב לדד ליין להזנת הפרויקטים בתיאום עם מוביל יום מעשים טובים ברשות</strong></p>
                        <p>עדכון לגבי גובה הסיוע יישלח במייל למוביל יום מעשים טובים ברשות.</p>
                    </div>}
                    <div className='d-flex justify-content-center mt-4'>
                        {/* <button autoFocus onClick={() => setModalShow(false)} className='f-bold btn btn-primary text-center' dangerouslySetInnerHTML={{__html: props.mainDataObj?.PopupPages[popupInfoIndex].ButtonText}}></button> */}
                       
                        <button autoFocus onClick={() => setModalShow(false)} className='f-bold btn btn-primary text-center'>הבנתי תודה</button>
                    </div>
                </div>}
            </Modal>
            
        </>
    )
}